"use client"

import dynamic from "next/dynamic"

const Analytics = dynamic(() => import("@vercel/analytics/react").then((m) => m.Analytics), {
  ssr: false,
})

const ScrollToTop = dynamic(() => import("@/components/scroll-to-top").then((m) => m.ScrollToTop), {
  ssr: false,
})

const SmoothScroll = dynamic(() => import("@/components/smooth-scroll").then((m) => m.SmoothScroll), {
  ssr: false,
})

/** Analytics: defer until after first paint. */
export function DeferredTickerAndAnalytics() {
  return <Analytics />
}

export function DeferredScrollToTop() {
  return <ScrollToTop />
}

export function DeferredSmoothScroll() {
  return <SmoothScroll />
}
